export default __webpack_public_path__ + "static/media/black_logo.e58febb0.png";